import { computed, ref } from "vue";

const KEY = "makemea-stats-password";

// Kept for this browser tab only, so closing the tab logs out
function load() {
  try {
    return sessionStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export const password = ref(load());
export const loggedIn = computed(() => password.value !== "");

export function setPassword(value) {
  password.value = value;
  try {
    sessionStorage.setItem(KEY, value);
  } catch {
    // Still logged in until the page is reloaded
  }
}

export function logOut() {
  password.value = "";
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing stored
  }
}

export function apiUrl(endpoint) {
  return `${process.env.VUE_APP_APIURL}/api/v1/${endpoint}`;
}
